import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: false,
        themes: {
            light: {
                'app-bar': '#00adee',
                primary: '#00adee', //00563b
                secondary:  '#00adee', //'#427034',   //006f49
                anchor: '#00adee',
                primaryText: colors.purple.accent1,
                secondaryText: colors.white,
                background: colors.blueGrey.lighten4,
                mycolor: colors.purple.base,
                buttonColor: '#ffffff'
            },
            dark: {
                // background: colors.pink.base,
                // mycolor: colors.purple.base
            },
        },
        options: {
            customProperties: true
        },
    },
});
